import {CONFIRMATION_STATE} from "../../constants";

export const couldBeSkipped = (step) => step && step.skippable && step.confirmationState !== CONFIRMATION_STATE.CONFIRMED